import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";

const PdfViewer7 = () => {
  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("pdf.QD356");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src="/uploads/QĐ Thi hành Luật bảo vệ dữ liệu cá nhân_356-nd.signed.pdf"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="dieukhoan"
      ></iframe>
    </div>
  );
};

export default PdfViewer7;
